ApplicationAdapter = require '../adapters/application'

App.ApiUserAdapter = ApplicationAdapter.extend
  buildURL: (type, id, record) ->
    endpoint = Em.String.singularize(@pathForType(type))
    [ @urlPrefix(), endpoint ].join('/')
